/** Pharmacy Type filter options for the NYCBS External table. */
export const allPharmacyTypeOptions = [
  { label: "Internal", value: "Internal" },
  { label: "External", value: "External" },
];
